/** Read break time from API payloads (camelCase or PascalCase). */
export function readOsiBreakTimeMinutes(
  source: Record<string, unknown> | null | undefined
): number | null {
  if (!source) return null
  const raw = source.breakTimeMinutes ?? source.BreakTimeMinutes
  if (raw === '' || raw == null) return null
  const value = Number(raw)
  return Number.isFinite(value) ? value : null
}

export function formatVosDurationMinutes(totalMinutes: number): string {
  if (!Number.isFinite(totalMinutes) || totalMinutes <= 0) return '0 mins'
  return `${Math.round(totalMinutes)} mins`
}

export function formatVosDurationWithBreak(
  netMinutes: number,
  breakMinutes?: number | null,
  deductionEnabled?: boolean
): string {
  const base = formatVosDurationMinutes(netMinutes)
  if (breakMinutes == null || breakMinutes <= 0) return base
  if (deductionEnabled) return `${base} excluding ${breakMinutes} min break`
  return `${base} including ${breakMinutes} min break`
}

export function computeVosDurations(
  start?: string,
  end?: string,
  breakMinutes?: number | null,
  deductionEnabled?: boolean
): {totalMinutes: number; netMinutes: number} {
  if (!start || !end) return {totalMinutes: 0, netMinutes: 0}
  const startMs = new Date(start).getTime()
  const endMs = new Date(end).getTime()
  const totalMinutes = Math.max(0, Math.ceil((endMs - startMs) / 60000))
  const breakValue = breakMinutes ?? 0
  const netMinutes = deductionEnabled
    ? Math.max(0, totalMinutes - breakValue)
    : totalMinutes
  return {totalMinutes, netMinutes}
}
